angular.module('app.dashboardService', [

])

.factory('dashboardService', ['$http', '$q', 'appSettings', function ( $http, $q, appSettings ) {

  return {
    
    getDespacho: function( data ) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getDespacho')
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    },
    
    getDeptoMunicipioCentros: function(p_id_departamento,p_id_estado,p_opcion) {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Departamento/'+p_id_departamento+
                                                      '/Estado/'+p_id_estado+
                                                      '/Opcion/'+p_opcion+'/getDeptoMunicipioCentros')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getDespachos: function(p_id_departamento, p_id_municipio,p_id_competencia) {
   
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Catalogos/Departamento/'+p_id_departamento+
                                                              '/Municipio/'+p_id_municipio+
                                                             '/Competencia/'+p_id_competencia+'/getDespachos')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
                //toastr.success("Consumi Servicio")
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
                //toastr.error("Fallo Consumir Servicio" + error)
            }
        return deferred.promise;

    },

    getMetrica1: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica1')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica2: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica2')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica3: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica3')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica4: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica4')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica5: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica5')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica6: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica6')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica7: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica7')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica8: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica8')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica9: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica9')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica10: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica10')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica11: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica11')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica12: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica12')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica13: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica13')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica14: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica14')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica15: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica15')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica16: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica16')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica17: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica17')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getMetrica18: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getMetrica18')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getCasosPorEstado: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getCasosPorEstado')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getCasosPorMateria: function(p_fecha,p_rango,p_id_centro) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Fecha/'+p_fecha+'/Rango/'+p_rango+'/Centro/'+p_id_centro+'/getCasosPorMateria')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    getDatosTablero: function(p_id_region,p_id_departamento,p_id_centro,p_fecha,p_fecha_fin,p_tipo_datos,p_id_base_color) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Region/'+p_id_region+
                                                                '/Departamento/'+p_id_departamento+
                                                                '/Centro/'+p_id_centro+
                                                                '/Fecha/'+p_fecha+
                                                                '/FechaFin/'+p_fecha_fin+
                                                                '/TipoDatos/'+p_tipo_datos+
                                                                '/Gama/'+p_id_base_color+
                                                                '/getDatosTablero')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
    },

    //auxiliares para servicios en home
    getFacilitadoresMediacion: function(p_tipo,p_region,p_departamento_iso,p_fecha,p_fecha_fin) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+
                                                              '/Region/'+p_region+
                                                             '/Departamento/'+p_departamento_iso+
                                                            '/Fecha/'+p_fecha+
                                                            '/Fecha_fin/'+p_fecha_fin+
                                                           '/getFacilitadoresMediacion')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
      },

      getCoberturaMediacion: function(p_tipo,p_region,p_departamento_iso,p_id_base_color) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+
                                                              '/Region/'+p_region+
                                                             '/Departamento/'+p_departamento_iso+
                                                            '/Gama/'+p_id_base_color+
                                                           '/getCoberturaMediacion')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
      },

      getCoberturaFacilitadores: function(p_tipo,p_region,p_departamento_iso,p_fecha,p_fecha_fin,p_id_base_color) {
        var deferred = $q.defer();
        $http.get(appSettings.restApiServiceBaseUri + 'Dashboard/Tipo/'+p_tipo+
                                                              '/Region/'+p_region+
                                                             '/Departamento/'+p_departamento_iso+
                                                            '/Fecha/'+p_fecha+
                                                            '/Fecha_fin/'+p_fecha_fin+
                                                           '/Gama/'+p_id_base_color+
                                                          '/getCoberturaFacilitadores')
        .then(successCallback, errorCallback);
            function successCallback(data){
                //success code
                deferred.resolve( data );
            }
            function errorCallback(error){
                //error code
                deferred.reject( error );
            }
        return deferred.promise;
      },

    getBaseColor: function( data ) 
    {
        var deferred = $q.defer();
        $http.get( appSettings.restApiServiceBaseUri + 'Catalogos/getBaseColor')
        .then(successCallback, errorCallback);
        function successCallback(data)
        {
            deferred.resolve( data );
        }
        function errorCallback(error)
        {
            deferred.reject( error );
        }
        return deferred.promise;
    }

  }

}]);
